module.exports = __webpack_public_path__ + "img/1723083812158-lapis rainbow.jpg.3eaa374b.webp";